<template>
  <div class="bg-white py-6 px-12">
    <p class="text-left text-lg mb-4">{{ $t("我的银行卡") }}</p>
    <div class="flex flex-wrap">
      <div
        class="border-1 w-15.5rem h-8.5rem mb-8 mr-3"
        v-for="item in card_message"
        :key="item.id"
      >
        <div
          class="
            bg-mainGray
            grid grid-cols-[auto,3.3rem]
            items-center
            gap-2
            h-3.5rem
            pl-2
          "
        >
          <!-- <p
            class="
              iconfont
              icon-gongshang
              text-1.9rem text-right text-hex-C6000B
            "
          ></p> -->
          <p class="text-left">
            <span class="block text-0.95rem font-semibold">{{
              item.banktype.value
            }}</span>
            <span class="block text-sm mt-1"
              >{{ $t("尾号") }}：{{
                $stringLast((item && item.cardno) || "", 4)
              }}</span
            >
          </p>
          <p
            class="
              w-2.8rem
              h-1.3rem
              text-0.75rem
              flex-center
              text-hex-3298F0
              bg-blue-200
              rounded-sm
            "
          >
            {{ $t("银行卡") }}
          </p>
        </div>
        <div class="p-3 text-sm space-y-3">
          <div class="flex flex-between">
            <span>{{ $t("持卡人") }}：{{ maskCardName(item.name) }}</span>
            <span
              class="text-gray-400 cursor-pointer"
              @click="editCard(item)"
              >{{ $t("编辑") }}</span
            >
          </div>
          <div class="flex flex-between">
            <!-- <span>手机号：152*****1104</span> -->
            <span>&nbsp;</span>
            <span
              class="text-gray-400 cursor-pointer"
              @click="delCard(item.id)"
              >{{ $t("删除") }}</span
            >
          </div>
        </div>
      </div>

      <div
        class="
          border-1
          w-15.5rem
          h-8.5rem
          border-hex-7EBFF5
          text-hex-3298F0
          pt-10
        "
        @click="addCard"
      >
        <p class="iconfont icon-tianjia"></p>
        <p>{{ $t("去添加银行卡") }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, onMounted } from "@vue/composition-api";
export default {
  setup(props, ctx) {
    const addCard = () => {
      ctx.root.$router.push({
        name: "addCard",
      });
    };
    const card_message = ref();

    const getBankCards = async () => {
      card_message.value = (
        await ctx.root.$callapi("user/getBankCards", { page: 1, size: 100 })
      ).data.items;
    };
    //页面加载时获取银行卡信息
    onMounted(() => {
      getBankCards();
    });
    //隐藏银行卡姓名
    const maskCardName = (no) => {
      return "**" + no.substr(no.length - 1);
    };
    //删除银行卡
    const delCard = async (id) => {
      const res = await ctx.root.$query(ctx.root.$t("您确认删除该银行卡"));
      if (res) {
        ctx.root.$doing();
        const res = await ctx.root.$callapi("user/delBankCards", {
          ids: id,
        });
        if (res && res.code == 0) {
          getBankCards();
        }
        ctx.root.$done();
      }
    };
    //编辑银行卡
    const editCard = (item) => {
      ctx.root.$router.push({ name: "addCard", query: { item } });
    };
    return { addCard, card_message, delCard, maskCardName, editCard };
  },
};
</script>
<style lang="scss" scoped></style>
